const getPodcastGuidFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('guid') || '';
};

const renderPodcastEpisodeDetail = async (container) => {
  const guid = getPodcastGuidFromUrl();
  const proxyBase = container.dataset.episodeProxyBase;
  const fallbackFeedTitle = container.dataset.fallbackFeedTitle || 'Podcast';
  const loadingEl = container.querySelector('.podcast-episode-detail__loading');
  const errorEl = container.querySelector('[data-podcast-episode-error]');
  const card = container.querySelector('[data-podcast-episode-card]');
  if (!guid) {
    loadingEl?.remove();
    if (errorEl) errorEl.hidden = false;
    return;
  }
  try {
    let payload;
    if (proxyBase) {
      const response = await fetch(`${proxyBase}?guid=${encodeURIComponent(guid)}`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Episode request failed: ${response.status}`);
      payload = await response.json();
    } else {
      // fallback when no episode endpoint exists: fetch all and search client-side
      const fullFeed = await (window.fetchPodcastPayload ? window.fetchPodcastPayload('https://feed.podbean.com/casualswinger/feed.xml') : fetchPodcastPayload('https://feed.podbean.com/casualswinger/feed.xml'));
      payload = {
        feed: fullFeed.feed,
        episode: (fullFeed.episodes || []).find((item) => String(item.guid) === String(guid))
      };
    }
    const feedTitle = payload.feed?.title || fallbackFeedTitle;
    const episode = payload.episode;
    if (!episode) throw new Error('Episode not found');
    const feedTitleEl = container.querySelector('[data-podcast-episode-feed-title]');
    const titleEl = container.querySelector('[data-podcast-episode-title]');
    const metaEl = container.querySelector('[data-podcast-episode-meta]');
    const artEl = container.querySelector('[data-podcast-episode-art]');
    const audioEl = container.querySelector('[data-podcast-episode-audio]');
    const summaryEl = container.querySelector('[data-podcast-episode-summary]');
    const notesEl = container.querySelector('[data-podcast-episode-notes]');
    const externalEl = container.querySelector('[data-podcast-episode-external]');
    if (feedTitleEl) feedTitleEl.textContent = feedTitle;
    if (titleEl) titleEl.textContent = episode.title || 'Podcast episode';
    if (metaEl) {
      const bits = [window.formatPodcastDate(episode.pubDate)];
      if (episode.duration) bits.push(episode.duration);
      if (episode.season) bits.push(`Season ${episode.season}`);
      if (episode.episode) bits.push(`Episode ${episode.episode}`);
      metaEl.textContent = bits.filter(Boolean).join(' • ');
    }
    if (artEl) { artEl.src = episode.image || payload.feed?.image || ''; artEl.alt = episode.title || feedTitle; }
    if (audioEl && episode.audioUrl) audioEl.src = episode.audioUrl;
    if (summaryEl) summaryEl.textContent = window.truncate(window.stripHtml(episode.summary || episode.description || ''), 320);
    if (notesEl) notesEl.innerHTML = episode.description || episode.summary || '';
    if (externalEl && episode.link) externalEl.href = episode.link;
    document.title = `${episode.title || 'Podcast episode'} · ${feedTitle}`;
    loadingEl?.remove();
    if (card) card.hidden = false;
  } catch (error) {
    console.error(error);
    loadingEl?.remove();
    if (errorEl) errorEl.hidden = false;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-podcast-episode-detail]').forEach((container) => {
    renderPodcastEpisodeDetail(container);
  });
});
